import {
  backgroundColorCss,
  mobileBackgroundColorCss,
} from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

const BlogPostContentContainerUi = styled.div<{
  backgroundColor?: string
  mobileBackgroundColor?: string
}>`
  margin-right: 1px;
  ${backgroundColorCss}
  ${p => p.theme.isEditorMobileMode && mobileBackgroundColorCss}
  ${p => p.theme.phone} {
    ${mobileBackgroundColorCss}
  }
`

export default BlogPostContentContainerUi
